<template>
  <div>
    <Breadcrumbs :items="breadcrumbs" page_title="courseevaluationreport" />
    <v-container fluid>
      <v-card>
        <v-row justify="space-between" class="pa-3">
          <v-col cols="12" lg="3">
            <v-text-field
              outlined
              dense
              hide-details
              style="border-radius: 8px; border-color: #c0c0c0"
              clearable
              prepend-inner-icon="mdi-magnify"
              :placeholder="$t('search')"
              v-model="search"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="7" style="text-align: right !important">
            <v-btn
              outlined
              :disabled="
                loading || loadError || exporting || !filteredSummary.length
              "
              :loading="exporting"
              @click="exportSummaryExcel()"
              style="
                color: #a6cc39;
                font-size: 16px;
                border: 1px solid #c0c0c0;
                box-shadow: unset !important;
                border-radius: 8px;
                background: #ffffff 0% 0% no-repeat padding-box;
              "
              class="ml-3 text-capitalize"
            >
              <v-icon class="mr-2 mb-1">mdi-export-variant</v-icon>
              {{ $t("exportexcel") }}
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row no-gutters>
          <v-col auto class="px-2">
            <v-data-table
              :loading="loading"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="summaryList"
              :search="search"
              :custom-filter="matchSearch"
              hide-default-footer
              @page-count="pageCount = $event"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              class="pt-6 px-2 report-table eval-table"
              item-key="assignmentCourseID"
              :no-results-text="$t('nodata')"
              @click:row="openDetail"
            >
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.courseName="{ item }">
                <div>{{ item.courseName }}</div>
                <v-chip
                  v-for="k in statusKeys(item)"
                  :key="k"
                  x-small
                  label
                  :class="'eval-chip-' + k"
                  class="mr-1 mt-1"
                  >{{ $t(k) }}</v-chip
                >
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.assignedCount="{ item }">
                {{ fmtInt(item.assignedCount) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.respondentCount="{ item }">
                {{ fmtInt(item.respondentCount) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.responseRate="{ item }">
                {{ fmt2(item.responseRate) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.avg_content="{ item }">
                {{ fmt2(item.avg_content) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.avg_instructor="{ item }">
                {{ fmt2(item.avg_instructor) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.avg_mediaDisplay="{ item }">
                {{ fmt2(item.avg_mediaDisplay) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.avg_supportingMaterial="{ item }">
                {{ fmt2(item.avg_supportingMaterial) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.avg_systemUsability="{ item }">
                {{ fmt2(item.avg_systemUsability) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.avg_overall="{ item }">
                {{ fmt2(item.avg_overall) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.averageAll="{ item }">
                {{ fmt2(item.averageAll) }}
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  small
                  :aria-label="$t('detail')"
                  @click.stop="openDetail(item)"
                >
                  <v-icon color="#ECC407">mdi-alert-circle</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <span v-if="loadError" style="color: #d32f2f">{{
                  $t("evalloadfailed")
                }}</span>
                <span v-else>{{ $t("evalnocourse") }}</span>
              </template>
              <template v-slot:no-results>
                {{ $t("nodata") }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row no-gutters class="pa-2 mt-2">
          <v-col cols="12" xs="12" sm="12" lg="10" md="8" xl="10">
            <div class="d-flex text-left">
              <v-pagination
                circle
                v-model="page"
                class="pagination"
                :length="pageCount"
              ></v-pagination>
            </div>
          </v-col>
          <v-col
            cols="12"
            lg="2"
            md="4"
            sm="12"
            xl="2"
            class="d-flex justify-end"
          >
            <p class="mt-3 pr-4">{{ $t("Show") }}</p>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  width="70"
                  v-bind="attrs"
                  v-on="on"
                  style="border: 1px solid #c0c0c0; opacity: 1"
                  class="text-capitalize mt-1 mr-2"
                  outlined
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in paginationCount"
                  :key="index"
                  @click="itemsPerPage = item.title"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <!-- F07 DSD: รายละเอียดผลประเมินรายหลักสูตร -->
    <v-dialog v-model="detailDialog" width="1200" persistent :scrollable="true">
      <v-card data-testid="course-evaluation-detail">
        <v-card-title style="font-size: 20px">
          <v-icon
            class="mr-1"
            style="padding-bottom: 3px; color: #363636; font-size: 30px"
            >mdi-alert-circle-outline</v-icon
          >
          <span class="eval-title">{{ detail ? detail.courseName : "" }}</span>
          <template v-if="detail">
            <v-chip
              v-for="k in statusKeys(detail)"
              :key="k"
              x-small
              label
              :class="'eval-chip-' + k"
              class="ml-2"
              >{{ $t(k) }}</v-chip
            >
          </template>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            :disabled="detailLoading || detailError || exporting || !detail"
            :loading="exporting"
            @click="exportDetailExcel()"
            style="
              color: #a6cc39;
              font-size: 16px;
              border: 1px solid #c0c0c0;
              box-shadow: unset !important;
              border-radius: 8px;
              background: #ffffff 0% 0% no-repeat padding-box;
            "
            class="mr-3 text-capitalize"
          >
            <v-icon class="mr-2 mb-1">mdi-export-variant</v-icon>
            {{ $t("exportexcel") }}
          </v-btn>
          <v-btn
            icon
            :aria-label="$t('close')"
            @click="closeDetail()"
            color="#424242"
            style="
              border-radius: 8px !important;
              border: 1px solid rgba(66, 66, 66, 0.05);
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          <v-alert v-if="detailError" type="error" text>
            {{ $t("evalloadfailed") }}
          </v-alert>

          <v-row>
            <v-col
              v-for="s in detailStats"
              :key="s.label"
              cols="6"
              sm="6"
              md="3"
            >
              <div class="eval-label">{{ $t(s.label) }}</div>
              <div class="eval-value">{{ s.value }}</div>
            </v-col>
          </v-row>

          <div class="eval-label mt-6 mb-2">{{ $t("evaldistribution") }}</div>
          <v-data-table
            :headers="distHeaders"
            :items="distributionRows"
            :loading="detailLoading"
            loading-text="Loading... Please wait"
            hide-default-footer
            disable-pagination
            disable-sort
            item-key="key"
            class="report-table"
          >
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.label="{ item }">
              {{ $t(item.label) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.average="{ item }">
              {{ fmt2(item.average) }}
            </template>
          </v-data-table>

          <div class="eval-label mt-6 mb-2">{{ $t("evalresponses") }}</div>
          <v-data-table
            :headers="respHeaders"
            :items="responseItems"
            item-key="courseEvaluationID"
            :loading="detailLoading"
            loading-text="Loading... Please wait"
            hide-default-footer
            :page.sync="respPage"
            @page-count="respPageCount = $event"
            :items-per-page="respItemsPerPage"
            class="report-table eval-table-resp"
          >
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.fullName="{ item }">
              <div>{{ item.fullName }}</div>
              <v-chip
                v-if="item.stillAssigned === false"
                x-small
                label
                class="eval-chip-evalnotassigned mt-1"
                >{{ $t("evalnotassigned") }}</v-chip
              >
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.submitDate="{ item }">
              {{ formatLocalDateTime(item.submitDate) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.average="{ item }">
              {{ fmt2(item.average) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.comment="{ item }">
              <div class="eval-comment">{{ item.comment }}</div>
            </template>
            <template v-slot:no-data>
              {{ detailError ? "" : $t("evalnoresponse") }}
            </template>
          </v-data-table>
          <div v-if="respPageCount > 1" class="d-flex text-left mt-2">
            <v-pagination
              circle
              v-model="respPage"
              class="pagination"
              :length="respPageCount"
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="4000" color="error">
      {{ $t("evalloadfailed") }}
    </v-snackbar>
  </div>
</template>

<script>
// F07 DSD — รายงานผลประเมินความพึงพอใจหลักสูตร (DSD ข้อ 7.1)
import exceljs from "exceljs";
import { saveAs } from "file-saver";

const TOPICS = [
  { key: "content", label: "evaltopiccontent", score: "contentScore" },
  { key: "instructor", label: "evaltopicinstructor", score: "instructorScore" },
  {
    key: "mediaDisplay",
    label: "evaltopicmediadisplay",
    score: "mediaDisplayScore",
  },
  {
    key: "supportingMaterial",
    label: "evaltopicmaterial",
    score: "supportingMaterialScore",
  },
  {
    key: "systemUsability",
    label: "evaltopicsystem",
    score: "systemUsabilityScore",
  },
  { key: "overall", label: "evaltopicoverall", score: "overallScore" },
];
const THIN_BORDER = {
  top: { style: "thin" },
  left: { style: "thin" },
  bottom: { style: "thin" },
  right: { style: "thin" },
};
const XLSX_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

export default {
  name: "CourseEvaluationReport",
  data() {
    return {
      breadcrumbs: [
        { sidebar_tilte: "report" },
        { text: "courseevaluationreport" },
      ],
      search: "",
      loading: false,
      loadError: false,
      summaryList: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      paginationCount: [{ title: 10 }, { title: 20 }, { title: 30 }],
      snackbar: false,
      detailDialog: false,
      detailLoading: false,
      detailError: false,
      detail: null,
      detailReq: 0,
      respPage: 1,
      respPageCount: 0,
      respItemsPerPage: 10,
      exporting: false,
    };
  },
  computed: {
    headers() {
      const num = { align: "center", filterable: false };
      return [
        { text: "#", value: "no", width: "60px", ...num },
        {
          text: this.$t("course"),
          value: "courseName",
          align: "left",
          width: "250px",
        },
        {
          text: this.$t("courseperiod"),
          value: "coursePeriod",
          width: "200px",
          ...num,
        },
        { text: this.$t("evalassigned"), value: "assignedCount", ...num },
        { text: this.$t("evalrespondents"), value: "respondentCount", ...num },
        { text: this.$t("evalresponserate"), value: "responseRate", ...num },
        ...TOPICS.map((t) => ({
          text: this.$t(t.label),
          value: "avg_" + t.key,
          width: "110px",
          ...num,
        })),
        {
          text: this.$t("evalaverageall"),
          value: "averageAll",
          width: "110px",
          ...num,
        },
        {
          text: this.$t("detail"),
          value: "actions",
          sortable: false,
          ...num,
        },
      ];
    },
    filteredSummary() {
      return this.summaryList.filter((item) =>
        this.matchSearch(item.courseName, this.search)
      );
    },
    detailStats() {
      const d = this.detail || {};
      return [
        { label: "evalassigned", value: this.fmtInt(d.assignedCount) },
        { label: "evalrespondents", value: this.fmtInt(d.respondentCount) },
        { label: "evalresponserate", value: this.fmt2(d.responseRate) },
        { label: "evalaverageall", value: this.fmt2(d.averageAll) },
      ];
    },
    distHeaders() {
      const c = { align: "center", sortable: false };
      return [
        { text: this.$t("topic"), value: "label", align: "left", sortable: false },
        { text: "1", value: "count1", ...c },
        { text: "2", value: "count2", ...c },
        { text: "3", value: "count3", ...c },
        { text: "4", value: "count4", ...c },
        { text: "5", value: "count5", ...c },
        { text: this.$t("evalaverage"), value: "average", ...c },
      ];
    },
    distributionRows() {
      const d = this.detail || {};
      const dist = Array.isArray(d.distribution) ? d.distribution : [];
      return TOPICS.map((t) => {
        const r = dist.find((x) => x.topic === t.key) || {};
        return {
          key: t.key,
          label: t.label,
          count1: r.count1 || 0,
          count2: r.count2 || 0,
          count3: r.count3 || 0,
          count4: r.count4 || 0,
          count5: r.count5 || 0,
          average: d.averages ? d.averages[t.key] : null,
        };
      });
    },
    respHeaders() {
      const c = { align: "center" };
      return [
        { text: "#", value: "no", width: "60px", ...c },
        { text: this.$t("name"), value: "fullName", width: "200px" },
        { text: this.$t("group"), value: "groupName", width: "150px" },
        {
          text: this.$t("evalsubmitdate"),
          value: "submitDate",
          width: "160px",
          ...c,
        },
        ...TOPICS.map((t) => ({
          text: this.$t(t.label),
          value: t.score,
          width: "110px",
          ...c,
        })),
        { text: this.$t("evalaverage"), value: "average", width: "100px", ...c },
        {
          text: this.$t("evalcommentcol"),
          value: "comment",
          sortable: false,
          width: "280px",
        },
      ];
    },
    responseItems() {
      return this.detail && Array.isArray(this.detail.responses)
        ? this.detail.responses
        : [];
    },
  },
  mounted() {
    this.getSummary();
  },
  methods: {
    async getSummary() {
      this.loading = true;
      this.loadError = false;
      this.summaryList = [];
      try {
        const res = await this.$axios.post(
          `${this.web_urlV7}CourseEvaluation/GetCourseEvaluationSummary`,
          { companyID: localStorage.getItem("companyID") }
        );
        if (res.data.status == 0) {
          this.summaryList = (res.data.data || []).map((v, i) => ({
            ...v,
            no: i + 1,
            coursePeriod: this.periodText(v),
            ...this.flattenAverages(v),
          }));
        } else {
          this.loadError = true;
          this.snackbar = true;
        }
      } catch (e) {
        console.error(e);
        this.loadError = true;
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },
    flattenAverages(v) {
      const out = {};
      TOPICS.forEach((t) => {
        out["avg_" + t.key] = v.averages ? v.averages[t.key] : null;
      });
      return out;
    },
    openDetail(item) {
      this.detailDialog = true;
      this.getDetail(item);
    },
    async getDetail(item) {
      const req = ++this.detailReq;
      this.detailLoading = true;
      this.detailError = false;
      this.detail = {
        assignmentCourseID: item.assignmentCourseID,
        courseName: item.courseName,
        courseStatus: item.courseStatus,
        evaluationEnabled: item.evaluationEnabled,
      };
      this.respPage = 1;
      try {
        const res = await this.$axios.post(
          `${this.web_urlV7}CourseEvaluation/GetCourseEvaluationDetail`,
          {
            companyID: localStorage.getItem("companyID"),
            assignmentCourseID: item.assignmentCourseID,
          }
        );
        if (req !== this.detailReq) return;
        if (res.data.status == 0 && res.data.data) {
          const data = res.data.data;
          this.detail = {
            ...data,
            responses: (data.responses || []).map((r, i) => ({
              ...r,
              no: i + 1,
            })),
          };
        } else {
          this.detailError = true;
        }
      } catch (e) {
        if (req !== this.detailReq) return;
        console.error(e);
        this.detailError = true;
      } finally {
        if (req === this.detailReq) this.detailLoading = false;
      }
    },
    closeDetail() {
      this.detailDialog = false;
      this.detailReq++;
      this.detail = null;
      this.detailError = false;
      this.detailLoading = false;
    },
    periodText(v) {
      return v && v.startDateTime && v.endDateTime
        ? this.changeDateFormat(v.startDateTime, "date") +
            " - " +
            this.changeDateFormat(v.endDateTime, "date")
        : "-";
    },
    fmt2(v) {
      return v == null || v === "" || isNaN(Number(v))
        ? "-"
        : Number(v).toFixed(2);
    },
    fmtInt(v) {
      return v == null ? "-" : v;
    },
    statusKeys(item) {
      const keys = [];
      if (!item) return keys;
      if (item.evaluationEnabled === false) keys.push("evaldsdoff");
      if (item.courseStatus === false) keys.push("evalcourseclosed");
      return keys;
    },
    statusText(keys) {
      return keys.map((k) => this.$t(k)).join(", ");
    },
    formatLocalDateTime(iso) {
      if (!iso) return "-";
      const d = new Date(iso);
      if (isNaN(d.getTime())) return "-";
      const p = (x) => this.getPrefixZeroString(x, 2);
      return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(
        d.getHours()
      )}:${p(d.getMinutes())}`;
    },
    matchSearch(value, search) {
      return (
        search == null ||
        search === "" ||
        (value != null &&
          typeof value !== "boolean" &&
          value
            .toString()
            .toLocaleLowerCase()
            .indexOf(search.toLocaleLowerCase()) !== -1)
      );
    },
    safeCell(v) {
      const s = v == null ? "" : String(v);
      if (s === "-") return s;
      return /^[=+\-@\t\r]/.test(s) ? "'" + s : s;
    },
    num2(v) {
      return v == null || isNaN(Number(v)) ? "-" : Number(v);
    },
    numInt(v) {
      return v == null ? "-" : v;
    },
    styleHeader(row) {
      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ff9900" },
        };
        cell.font = { name: "Calibri", size: 11, bold: true };
        cell.border = THIN_BORDER;
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
      });
    },
    // headers: [{ text, decimal?, align? }] · rows: array ของ array ค่า
    addTable(ws, startRow, headers, rows) {
      const head = ws.getRow(startRow);
      headers.forEach((h, i) => {
        head.getCell(i + 1).value = h.text;
      });
      this.styleHeader(head);
      rows.forEach((values, r) => {
        const row = ws.getRow(startRow + 1 + r);
        values.forEach((val, i) => {
          const cell = row.getCell(i + 1);
          cell.value = val;
          cell.border = THIN_BORDER;
          cell.alignment = {
            vertical: "top",
            horizontal: headers[i].align || "center",
            wrapText: true,
          };
          if (headers[i].decimal && typeof val === "number") {
            cell.numFmt = "0.00";
          }
        });
      });
      return startRow + rows.length;
    },
    async saveWorkbook(wb, fileName) {
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf], { type: XLSX_TYPE }), fileName);
    },
    async exportSummaryExcel() {
      if (this.exporting) return;
      this.exporting = true;
      try {
        const wb = new exceljs.Workbook();
        const ws = wb.addWorksheet("Summary");
        const headers = [
          { text: "#" },
          { text: this.$t("course"), align: "left" },
          { text: this.$t("courseperiod") },
          { text: this.$t("status"), align: "left" },
          { text: this.$t("evalassigned") },
          { text: this.$t("evalrespondents") },
          { text: this.$t("evalresponserate"), decimal: true },
          ...TOPICS.map((t) => ({ text: this.$t(t.label), decimal: true })),
          { text: this.$t("evalaverageall"), decimal: true },
        ];
        ws.columns = [8, 40, 26, 24, 14, 14, 16, 16, 16, 16, 16, 16, 16, 16].map(
          (w) => ({ width: w })
        );
        const rows = this.filteredSummary.map((v, i) => [
          i + 1,
          this.safeCell(v.courseName),
          v.coursePeriod || "-",
          this.safeCell(this.statusText(this.statusKeys(v))),
          this.numInt(v.assignedCount),
          this.numInt(v.respondentCount),
          this.num2(v.responseRate),
          ...TOPICS.map((t) => this.num2(v["avg_" + t.key])),
          this.num2(v.averageAll),
        ]);
        this.addTable(ws, 1, headers, rows);
        await this.saveWorkbook(wb, "CourseEvaluationSummary.xlsx");
      } catch (e) {
        console.error(e);
        this.snackbar = true;
      } finally {
        this.exporting = false;
      }
    },
    async exportDetailExcel() {
      if (this.exporting || !this.detail) return;
      this.exporting = true;
      try {
        const d = this.detail;
        const wb = new exceljs.Workbook();

        // Sheet 1: Summary
        const ws = wb.addWorksheet("Summary");
        ws.columns = [30, 40, 10, 10, 10, 10, 14].map((w) => ({ width: w }));
        const info = [
          [this.$t("course"), this.safeCell(d.courseName)],
          [this.$t("courseperiod"), this.periodText(d)],
          [
            this.$t("status"),
            this.safeCell(this.statusText(this.statusKeys(d))),
          ],
          [this.$t("evalassigned"), this.numInt(d.assignedCount)],
          [this.$t("evalrespondents"), this.numInt(d.respondentCount)],
          [this.$t("evalresponserate"), this.num2(d.responseRate), true],
          [this.$t("evalaverageall"), this.num2(d.averageAll), true],
        ];
        info.forEach(([label, value, decimal], i) => {
          const row = ws.getRow(i + 1);
          const lc = row.getCell(1);
          lc.value = label;
          lc.font = { name: "Calibri", size: 11, bold: true };
          lc.border = THIN_BORDER;
          const vc = row.getCell(2);
          vc.value = value;
          vc.border = THIN_BORDER;
          vc.alignment = { horizontal: "left", wrapText: true };
          if (decimal && typeof value === "number") vc.numFmt = "0.00";
        });
        const distTitleRow = info.length + 2;
        const tc = ws.getRow(distTitleRow).getCell(1);
        tc.value = this.$t("evaldistribution");
        tc.font = { name: "Calibri", size: 11, bold: true };
        this.addTable(
          ws,
          distTitleRow + 1,
          [
            { text: this.$t("topic"), align: "left" },
            { text: "1" },
            { text: "2" },
            { text: "3" },
            { text: "4" },
            { text: "5" },
            { text: this.$t("evalaverage"), decimal: true },
          ],
          this.distributionRows.map((r) => [
            this.$t(r.label),
            r.count1,
            r.count2,
            r.count3,
            r.count4,
            r.count5,
            this.num2(r.average),
          ])
        );

        // Sheet 2: Responses
        const ws2 = wb.addWorksheet("Responses");
        ws2.columns = [8, 30, 20, 18, 14, 14, 14, 14, 14, 14, 12, 50, 22].map(
          (w) => ({ width: w })
        );
        this.addTable(
          ws2,
          1,
          [
            { text: "#" },
            { text: this.$t("name"), align: "left" },
            { text: this.$t("group"), align: "left" },
            { text: this.$t("evalsubmitdate") },
            ...TOPICS.map((t) => ({ text: this.$t(t.label) })),
            { text: this.$t("evalaverage"), decimal: true },
            { text: this.$t("evalcommentcol"), align: "left" },
            { text: this.$t("status"), align: "left" },
          ],
          (d.responses || []).map((r, i) => [
            i + 1,
            this.safeCell(r.fullName),
            this.safeCell(r.groupName),
            this.formatLocalDateTime(r.submitDate),
            ...TOPICS.map((t) => this.numInt(r[t.score])),
            this.num2(r.average),
            this.safeCell(r.comment),
            r.stillAssigned === false ? this.$t("evalnotassigned") : "",
          ])
        );

        const safeName = (d.courseName || "").replace(/[\\/:*?"<>|]/g, "");
        await this.saveWorkbook(wb, `CourseEvaluation - ${safeName}.xlsx`);
      } catch (e) {
        console.error(e);
        this.snackbar = true;
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 16px !important;
}
@media (min-width: 960px) {
  .container {
    max-width: unset !important;
  }
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 16px !important;
  color: #47484b !important;
  background-color: #e0e0e0 !important;
  opacity: 1;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 15px !important;
  color: #47484b !important;
  vertical-align: top;
}
::v-deep .report-table thead th:first-child {
  border-radius: 8px 0 0 8px !important;
}
::v-deep .report-table thead th:last-child {
  border-radius: 0 8px 8px 0 !important;
}
.report-table tr:nth-child(even) {
  background: unset;
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
  opacity: 1;
}
::v-deep .v-pagination__navigation {
  border-radius: 6px !important;
  box-shadow: none !important;
  border: 1px solid #c0c0c0;
}
::v-deep .eval-table .v-data-table__wrapper,
::v-deep .eval-table-resp .v-data-table__wrapper {
  overflow-x: auto;
}
::v-deep .eval-table th,
::v-deep .eval-table-resp th {
  white-space: normal;
}
::v-deep .eval-table tbody tr {
  cursor: pointer;
}
.eval-title {
  white-space: normal;
  word-break: break-word;
}
.eval-label {
  font-size: 16px;
  color: #47484b;
  font-weight: bold;
}
.eval-value {
  font-size: 18px;
  color: #47484b;
  margin-top: 4px;
}
.eval-comment {
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 120px;
  overflow-y: auto;
  min-width: 280px;
}
.eval-chip-evaldsdoff {
  background: #fff3e0 !important;
  color: #e65100 !important;
}
.eval-chip-evalcourseclosed,
.eval-chip-evalnotassigned {
  background: #eeeeee !important;
  color: #616161 !important;
}
</style>
